import { AxiosError } from "axios";
import useSWRInternal, { SWRConfiguration } from "swr";
import {
  ApiArrayResponse,
  getAxiosInstance,
  ServerResponse,
} from "./axiosConfig";

if (localStorage.getItem("WIS_API_URL")) {
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = localStorage.getItem("WIS_API_URL") ?? "";
  link.crossOrigin = "use-credentials";
  document.head.appendChild(link);
}

export const axiosInst = getAxiosInstance(
  localStorage.getItem("WIS_API_URL") || ""
);

export const fetcher = async <T>(
  url: string,
  requestBody?: unknown
): Promise<T> => {
  let res;
  if (requestBody === undefined) {
    res = await axiosInst.get(url);
  } else {
    res = await axiosInst.post(url, requestBody);
  }
  return res.data;
};

export const useSwr = <T = ApiArrayResponse<unknown>>(
  url: string | null,
  configuration?: SWRConfiguration,
  requestBody?: unknown
): ServerResponse<T> =>
  useSWRInternal<T, AxiosError<T>>(
    url != null ? [url, JSON.stringify(requestBody)] : null,
    fetcher,
    {
      ...configuration,
      // suspense can't be used with conditional fetching
      // https://github.com/vercel/swr/pull/357#issuecomment-627089889
      ...(url == null ? { suspense: false } : {}),
    }
  );
